import React, { useCallback } from "react";
import { RootState, useAppDispatch } from "../../Store";
import {
  hideNotification,
  showNotification,
} from "../../Store/Slices/notificationBarSlice";
import { useSelector } from "react-redux";

export const useTopBarNotification = () => {
  const dispatch = useAppDispatch();
  const notificationStatus = useSelector(
    (state: RootState) => state.notificationBar.status
  );

  const showTopBarNotification = useCallback((message: React.ReactNode) => {
    dispatch(showNotification(message));
  }, []); // eslint-disable-line

  const hideTopBarNotification = useCallback(() => {
    dispatch(hideNotification());
  }, []); // eslint-disable-line

  return {
    showTopBarNotification,
    hideTopBarNotification,
    notificationStatus
  };
};
